"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "totalRecords": 1,
    "skip": 0,
    "take": 100,
    "recordsReturned": 1,
    "data": [
        {
            "portfolioKey": "prt_9431687b9b2044aea20463de3980260e",
            "name": "Bullseye Test Portfolio 1",
            "clientAccountKey": "ca_1213d00e594b4088a1d591fb611a8181",
            "clientAccountName": "Bullseye Test1",
            "serviceType": "StatementOfAdvice",
            "totalReturnValue": -222702.660000,
            "totalReturnPercentage": -0.065364,
            "inceptionDate": "2020-12-31T00:00:00"
        }
    ]
};
